import { render } from "./ViewDetailsMore.vue?vue&type=template&id=65cf9570"
import script from "./ViewDetailsMore.vue?vue&type=script&lang=js"
export * from "./ViewDetailsMore.vue?vue&type=script&lang=js"

import "./ViewDetailsMore.vue?vue&type=style&index=0&id=65cf9570&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__